import Component from "../core/Component"

export const STATES = {
    VISIBLE: "is-visible",
    ACTIVE: "is-active",
    TOP: "is-top",
    LEFT: "is-left",
    BOTTOM: "is-bottom",
}

export default class EventRoomBubble extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            inner: null,
        }

        this.lastImage = null
    }

    prepare() {}

    show() {
        this.element.classList.add(STATES.ACTIVE)
        this.rect = this.element.getBoundingClientRect()
    }

    hide() {
        this.element.classList.remove(STATES.ACTIVE)
    }

    setImageSrc(src) {
        if (this.lastImage && this.lastImage.element.src === src) {
            return
        }

        if (this.lastImage) {
            this.lastImage.destroy()
            this.element.classList.remove("is-loading")
        }

        const image = createImage(src)
        this.ref.inner.appendChild(image.element)
        this.element.classList.add("is-loading")
        image.listen('loadend', () => {
            this.element.classList.remove("is-loading")
        })
        image.setSrc(src)
        this.lastImage = image
    }

    setPosition(position) {
        this.element.classList.remove(STATES.BOTTOM)
        this.element.classList.remove(STATES.LEFT)

        if (position.isBottom) {
            this.element.classList.add(STATES.BOTTOM)
        }

        if (position.isLeft) {
            this.element.classList.add(STATES.LEFT)
        }

        this.element.style.transform = `translate3d(${position.x}px,${position.y}px,0)`
    }

    getRect() {
        return this.rect
    }
}

function createImage() {
    let element = document.createElement("img")
    const fncs = {
        'loadend': () => {}
    }


    const listen = (fncName, fnc) => {
        fncs[fncName] = fnc
    }
    const setSrc = (src) => {
        element.src = src

        if (element.complete && element.naturalHeight !== 0) {
            fncs['loadend']()
        }
    }
    const loadEnd = () => {
        element.classList.add("is-active")
        fncs['loadend']()
    }
    const transitionEnd = () => {
        if (!element.classList.contains("is-active")) {
            element.parentNode.removeChild(element)
        }
    }
    const destroy = () => {
        element.removeEventListener("load", loadEnd)
        if (element.classList.contains("is-active")) {
            element.classList.remove("is-active")
        } else {
            element.parentNode.removeChild(element)
            element = null
        }
    }

    element.addEventListener("load", loadEnd)
    element.addEventListener("transitionend", transitionEnd)

    return {
        element,
        setSrc,
        listen,
        destroy,
    }
}
